export const synthetica_login = process.env.SYNTHETICA_LOGIN;
export const synthetica_pass = process.env.SYNTHETICA_PASS;

export const mockData = [];

export const TEST_VESSEL = 'IZUMI';
export const SEAJAPAN_TEST_VESSEL = 'ANDROMEDA';
